module.exports = require("ext2mime");